import { useEffect, useState } from "react";
import { PageHeader } from "../components/PageHeader";
import { CtaBand } from "../components/CtaBand";
import { AccessoriesSection } from "../components/AccessoriesSection";
import { API_URL } from "../config";

export default function Accessories() {
  const [colours, setColours] = useState([]);
  useEffect(() => {
    fetch(`${API_URL}/colours`).then((r) => r.json()).then(setColours).catch(() => {});
  }, []);
  return (
    <div data-testid="accessories-page">
      <PageHeader
        label="Scotia & Trims"
        title="Finishing accessories for a floor that looks complete"
        description="Colour-matched scotia and the right trims cover expansion gaps, protect edges and tie your new hybrid floor into the rest of the room. We supply and fit them with every install."
        testId="accessories-header"
      />
      <AccessoriesSection colours={colours} />
      <CtaBand title="Want the edges done properly?" text="Tell us about your rooms, doorways and steps — we will recommend the right scotia and trims and include them in your free quote." />
    </div>
  );
}
